module.exports = __webpack_public_path__ + "4e9c7db943655836b08d98744cd9c4c9.png";